import {Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material';
import {Customer} from '../../model/Entities/Customer';
import {CustomerContactPerson} from '../../model/Entities/CustomerContactPerson';
import {FormControl, Validators} from '@angular/forms';
import {User} from '../../model/Entities/User';

@Component({
    selector: 'customer-contact-person-dialog',
    templateUrl: './customer-contact-person.dialog.component.html',
    styleUrls: ['./customer-contact-person.dialog.component.scss']
})
export class CustomerContactPersonDialogComponent {

    person: CustomerContactPerson;
    editing = false;

    nameFC = new FormControl('', [
        Validators.required,
    ]);

    surnameFC = new FormControl('', [
        Validators.required,
    ]);

    emailFC = new FormControl('', [
        Validators.email,
    ]);

    constructor(public dialog: MatDialogRef<CustomerContactPersonDialogComponent>,
                @Inject(MAT_DIALOG_DATA) public data: any) {
        this.person = data.person;

        if (this.person === null) {
            this.person = new CustomerContactPerson();
        } else {
            this.editing = true;
        }
    }

    checkValidity(): boolean {
        return this.nameFC.valid
            && this.surnameFC.valid;
    }
}



// WEBPACK FOOTER //
// /app/src/CustomersModule/CustomerContactPersonDialogComponent/customer-contact-person.dialog.component.ts